import { Component } from '@angular/core';
import {Router} from '@angular/router';
import * as moment from 'moment-timezone';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { InfoUsuarioService } from '../../../core/services/info-usuario.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../shared/dialog-confirmacion/dialog-confirmacion.component';
import { AutenticacionService } from '../../../core/services/autenticacion.service';
import { SocialAuthService } from 'angularx-social-login';
import { MomentSetService } from '../../../core/services/moment-set.service';

declare var jQuery:any;

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.template.html',
  styleUrls: ['./navigation.component.css']
})

export class NavigationComponent {
  isExternalAuth: boolean;

  constructor(private router: Router, 
              private infoUsuarioService: InfoUsuarioService, 
              public dialog: MatDialog, 
              private autenticacionService: AutenticacionService, 
              private _socialAuthService: SocialAuthService,
              private momentService: MomentSetService) { }

  nombreUser: string;
  apellidoUser: string;
  menuData;
  menuProvi;
  permisoConfiguracion: boolean = false;
  zonaHorariaServer: string = '';
  currentHourServer: any;

  ngOnInit()
  {
    this.nombreUser = localStorage.getItem("FistNameUsuario");
    this.apellidoUser = localStorage.getItem("LastNameUsuario");

    this._socialAuthService.authState.subscribe(user =>
    {
      this.isExternalAuth = user != null;
    })

    this.menuProvi = [
      {
        //Posicion 0
        text: 'Tablero de Control', router: '/dashboards/dashboard2', class: 'fa fa-th-large'
      },
      {
        //Posicion 1
        text: 'Personal', class: 'fa fa-users', children: [
          { text: 'Alta Personal', router: '/personal/alta' },
          { text: 'Ficha Médica y Sanciones', router: '/personal/fichaMedica' },
          { text: 'Importación Datos Personal', router: '/personal/importacionDatos' },
          { text: 'Reportes Personal',  children: [ 
            { text: 'Lista Personal', router: '/personal/listaPersonas' },
            { text: 'Impresión Constancia', router: '/personal/impresionConstancia' }
            // { text: 'Fichas Médicas', router: '/personal/listaPersonas' }
          ]}
        ]
      },
      {
        //Posicion 2
        text: 'Fórmulas', class: 'fa fa-puzzle-piece', children: [
          { text: 'Definir Fórmula', router: '/blockly/blockly' },
          { text: 'Bases', router: '/configuracion/Bases' },
          { text: 'Acumuladores', router: '/configuracion/acumuladores' },
          { text: 'Constantes', router: '/configuracion/constantes' },
          { text: 'Promedios', router: '/configuracion/promedios' }
        ]
      },
      {
        //Posicion 3
        text: 'Gestión Organización', class: 'fa fa-sitemap', children: [
          { text: 'Funciones', router: '/configuracion/funciones' },
          { text: 'Centro de Costos', router: '/configuracion/centroCostos' },
          { text: 'Unidades Organizativas', router: '/configuracion/unidadesOrganizativas' },
          { text: 'Posiciones', router: '/configuracion/posiciones' },
          { text: 'Organigrama', router: '/configuracion/organigrama' }
        ]
      },
      {
        //Posicion 4
        text: 'Liquidación', class: 'fa fa-calculator', children: [
          { text: 'Liquidar', router: '/liquidacion/liquidar' },
          { text: 'Liquidar Baja', router: '/liquidacion/liquidarBaja' },
          { text: 'Resultado', router: ['/configuracion/resultadosliq', {opcion: 0}] },
          { text: 'Resultado Simulación', router: ['/configuracion/resultadosliqsimu', {opcion: 1}] },
          { text: 'Impresión', router: '/configuracion/resultadosLiqImp' },
          { text: 'Transferencia Bancaria', router: '/configuracion/reporteTransferencia' },
          { text: 'Reportes',  children: [ 
            { text: 'Resultados Nómina', router: '/configuracion/reporteResultadosNomina' },
            { text: 'Códigos de Nómina', router: '/configuracion/reporteCodigosNomina' },
            { text: 'Borrado Resultados Nómina', router: '/configuracion/borradoResultadosNomina' }
          ]}
        ]
      },
      {
        //Posicion 5
        text: 'Nómina', class: 'fa fa-inbox', children: [
          { text: 'Estructura Salarial', router: '/configuracion/estructuraSalariales' },
          { text: 'Clase Convenios', router: '/configuracion/claseConvenios' },
          { text: 'Área Convenios', router: '/configuracion/areaConvenios' },
          { text: 'Códigos de Nóminas', router: '/configuracion/codigosNominas' },
          { text: 'Grupos de Nóminas', router: '/configuracion/gruposNominas' },
          { text: 'Aportes Contribución', router: '/configuracion/aportesContribuciones' },
          { text: 'Niveles', router: '/configuracion/niveles' },
          { text: 'Subniveles', router: '/configuracion/subNiveles' }
        ]
      },
      {
        //Posicion 6
        text: 'Control de Nóminas', router: '/configuracion/controlNominas', class: 'fa fa-eye'
      },
      {
        //Posicion 7
        text: 'Control de Tiempos', class: 'fa fa-clock-o ', children: [
          { text: 'Plan Horario Diario', router: '/configuracion/planHorarioDiario' },
          { text: 'Plan Horario por Período', router: '/configuracion/planHorarioPeriodo' },
          { text: 'Reglas de Planes Horarios', router: '/configuracion/planHorarioReglas' },
          { text: 'Feriados', router: '/configuracion/feriados' },
          { text: 'Calendario de Trabajo', router: '/configuracion/calendarioTrabajo' }
        ]
      },
      {
        //Posicion 8
        text: 'Contabilidad', class: 'fa fa-bar-chart', children: [
          { text: 'Resultado Contable', router: '/configuracion/liquidacionConsulta' }
        ]
      },
      {
        //Posicion 9
        text: 'Configuracion', class: 'fa fa-gears', visible: false, children: [ 
          { text: 'Estructura Empresa',  children: [ 
            { text: 'Sociedades', router: '/configuracion/sociedades' },
            { text: 'Grupos', router: '/configuracion/grupos' },
            { text: 'Subgrupos', router: '/configuracion/subGrupos' },
            { text: 'Sedes', router: '/configuracion/sedes' },
            { text: 'Subsedes', router: '/configuracion/subSedes' },
            { text: 'Grupos Liquidación', router: '/configuracion/gruposLiquidaciones' },
            { text: 'Modelos Constancias', router: '/configuracion/modelosConstancias' }
          ]},
          { text: 'Datos Maestros',  children: [ 
            { text: 'Bancos', router: '/configuracion/bancos' },
            { text: 'Contratos', router: '/configuracion/claseContratos' },
            { text: 'Direcciones', router: '/configuracion/claseDirecciones' },
            { text: 'Documentos', router: '/configuracion/claseDocumentos' },
            { text: 'Familiares', router: '/configuracion/claseFamiliares' },
            { text: 'Fechas', router: '/configuracion/claseFechas' },
            { text: 'Afiliaciones', router: '/configuracion/claseAfiliaciones' },
            { text: 'Estado Civil', router: '/configuracion/estadoCivil' },
            { text: 'Estados de Nóminas', router: '/configuracion/estadosNominas' },
            { text: 'Obras Sociales', router: '/configuracion/obrasSociales' }
          ]},
          { text: 'Datos de Tiempos',  children: [ 
            { text: 'Ausentismos', router: '/configuracion/claseAusentismos' },
            { text: 'Contingentes', router: '/configuracion/claseContingentes' },
            { text: 'Unidades Tiempo', router: '/configuracion/unidadesTiempos' },
            { text: 'Calendarios Festivos', router: '/configuracion/calendariosFestivos' }
          ]},
          { text: 'Datos Generales',  children: [ 
            { text: 'Países', router: '/configuracion/paises' },
            { text: 'Provincias', router: '/configuracion/provincias' },
            { text: 'Idiomas', router: '/configuracion/idiomas' },
            { text: 'Tratamientos', router: '/configuracion/tratamientos' },
            { text: 'Unidades Medidas', router: '/configuracion/unidadesMedidas' },
            { text: 'Monedas', router: '/configuracion/monedas' },
            { text: 'Sexos', router: '/configuracion/sexos' },
            { text: 'Títulos', router: '/configuracion/titulos' },
            { text: 'Rubros', router: '/configuracion/rubros' }
          ]},
          { text: 'Datos Legales',  children: [ 
            { text: 'Actividades Empl.', router: '/configuracion/actividadEmpleado' },
            { text: 'Agrupamientos Empl.', router: '/configuracion/agrupamientoEmpleado' },
            { text: 'Carácteres Servicio', router: '/configuracion/caracterServicio' }
          ]},
          { text: 'Liquidación',  children: [ 
            { text: 'Esquemas', router: '/configuracion/Esquemas' },
            { text: 'Motivos Nómina Especial', router: '/configuracion/MotivosNominaEspecial' },
            { text: 'Motivos Baja', router: '/configuracion/MotivosBaja' }
          ]},
          { text: 'Control de Nóminas',  children: [ 
            { text: 'Tipo de Período', router: '/configuracion/periodoCabs' },
            { text: 'Períodos', router: '/configuracion/periodoDets' }
          ]},
          { text: 'Contabilidad',  children: [ 
            { text: 'Tipos de Cuenta', router: '/configuracion/tipoDeCuenta' },
            { text: 'Cuentas Agrupador', router: '/configuracion/cuentasAgrupador' },
            { text: 'Cuentas Simbólicas', router: '/configuracion/cuentasSimbolicas' },
            { text: 'Conceptos Cuentas Simbólicas', router: '/configuracion/conceptosCuentasSimbolicas' },
            { text: 'B1s Cuentas Contables SAP', router: '/configuracion/b1sCuentasContables' }
          ]},
          { text: 'Usuarios',  children: [ 
            { text: 'Usuarios', router: '/configuracion/usuarios' },
            { text: 'Roles', router: '/configuracion/roles' }
            //{ text: 'Permisos', router: '/configuracion/funcionesUsr' } No tiene sentido que el usuario 
            // pueda agregar permisos porque no estan en el codigo
          ]}
          // { text: 'Log de Errores', router: '/configuracion/erroresLog' }
        ]
      }
    ];

    this.verPermisos();
  }

  private updateCurrentHour() {
    const now = new Date();
    this.currentHourServer = this.momentService.convertDateServer(now);
  }

  async verPermisos() : Promise<void>  {
    this.zonaHorariaServer = localStorage.getItem("ZonaHorariaServer");
    this.momentService.setDefaultTimeZone(this.zonaHorariaServer);
    this.updateCurrentHour();
    setInterval(() => this.updateCurrentHour(), 60000); // Actualiza cada minuto la hora del servidor
    
    let permisos = localStorage.getItem("Permisos");
    let subitems;
    let subitems2;
    let subitems3;
    let subitems4;

    //Opcion 9 - Configuracion -> Revisa permiso y la elimina del menu si no lo tiene
    if (!permisos.includes("Configuracion"))
    {
      this.menuProvi.splice(9,1);
    } else
    {
      if (permisos.includes("Editar Configuracion IPS")) this.menuProvi[9].children[5].children.push({ text: 'Configuracion IPS', router: '/configuracion/configuracionIPS' });
      if (permisos.includes("Editar Configuracion IRP")) this.menuProvi[9].children[5].children.push({ text: 'Configuracion IRP', router: '/configuracion/configuracionIRP' });
      if (permisos.includes("Editar Configuracion MTESS")) this.menuProvi[9].children[5].children.push({ text: 'Configuracion MTESS', router: '/configuracion/configuracionMTESS' });
      if (permisos.includes("Editar Parametros Conexion SAP")) this.menuProvi[9].children[7].children.push({ text: 'Parametros Conexion SAP', router: '/configuracion/parametrosConexionSAP' });
    }    

    //Opcion 8 - Contabilidad -> Revisa permiso y la elimina del menu si no lo tiene
    subitems = [{ text: 'Registro de inicio', router: '' }];
    if (permisos.includes("Ver Resultado Contable")) subitems.push({ text: 'Resultado Contable', router: '/configuracion/liquidacionConsulta' });
    subitems.splice(0,1);
    if (subitems.length > 0)
    {
      this.menuProvi[8] = { text: 'Contabilidad', class: 'fa fa-bar-chart', children: subitems};
    } else
    {
      this.menuProvi.splice(8,1);
    }

    //Opcion 7 - Control de tiempos -> Revisa permiso y la elimina del menu si no lo tiene
    subitems = [{ text: 'Registro de inicio', router: '' }];
    if (permisos.includes("Ver Plan Horario-Diario")) subitems.push({ text: 'Plan Horario Diario', router: '/configuracion/planHorarioDiario' });
    if (permisos.includes("Ver Plan Horario-Periodo")) subitems.push({ text: 'Plan Horario por Período', router: '/configuracion/planHorarioPeriodo' });
    if (permisos.includes("Ver Plan Horario-Reglas")) subitems.push({ text: 'Reglas de Planes Horarios', router: '/configuracion/planHorarioReglas' });
    if (permisos.includes("Ver Feriados")) subitems.push({ text: 'Feriados', router: '/configuracion/feriados' });
    if (permisos.includes("Ver Calendario Trabajo")) subitems.push({ text: 'Calendario de Trabajo', router: '/configuracion/calendarioTrabajo' });
    subitems.splice(0,1);
    if (subitems.length > 0)
    {
      this.menuProvi[7] = { text: 'Control de Tiempos', class: 'fa fa-clock-o ', children: subitems};
    } else
    {
      this.menuProvi.splice(7,1);
    }

    //Opcion 6 - Control de Nóminas -> Revisa permiso y la elimina del menu si no lo tiene
    if (!permisos.includes("Ver Control de Nominas")) this.menuProvi.splice(6,1);

    //Opcion 5 - Nómina -> Revisa permiso y la elimina del menu si no lo tiene
    subitems = [{ text: 'Registro de inicio', router: '' }];
    if (permisos.includes("Ver Estructura Salarial")) subitems.push({ text: 'Estructura Salarial', router: '/configuracion/estructuraSalariales' });
    if (permisos.includes("Ver Clase Convenios")) subitems.push({ text: 'Clase Convenios', router: '/configuracion/claseConvenios' });
    if (permisos.includes("Ver Area Convenios")) subitems.push({ text: 'Área Convenios', router: '/configuracion/areaConvenios' });
    if (permisos.includes("Ver Codigos de Nomina")) subitems.push({ text: 'Códigos de Nóminas', router: '/configuracion/codigosNominas' });
    if (permisos.includes("Ver Grupos de Nomina")) subitems.push({ text: 'Grupos de Nóminas', router: '/configuracion/gruposNominas' });
    if (permisos.includes("Ver Aportes Contribucion")) subitems.push({ text: 'Aportes Contribución', router: '/configuracion/aportesContribuciones' });
    if (permisos.includes("Ver Niveles")) subitems.push({ text: 'Niveles', router: '/configuracion/niveles' });
    if (permisos.includes("Ver Subniveles")) subitems.push({ text: 'Subniveles', router: '/configuracion/subNiveles' });
    subitems.splice(0,1);
    if (subitems.length > 0)
    {
      this.menuProvi[5] = { text: 'Nómina', class: 'fa fa-inbox', children: subitems};
    } else
    {
      this.menuProvi.splice(5,1);
    }
    
    //Opcion 4 - Liquidacion -> Revisa permiso y la elimina del menu si no lo tiene
    subitems = [{ text: 'Registro de inicio', router: '' }];
    if (permisos.includes("Liquidar")) subitems.push({ text: 'Liquidar', router: ['/liquidacion/liquidar', {opcion: 0}] });
    if (permisos.includes("Liquidar")) subitems.push({ text: 'Liquidar Baja', router: ['/liquidacion/liquidarBaja', {opcion: 1}] });
    if (permisos.includes("Resultado Liquidacion")) 
    {
      subitems.push({ text: 'Resultado', router: ['/configuracion/resultadosliq', {opcion: 0}] });
      subitems.push({ text: 'Resultado Simulación', router: ['/configuracion/resultadosliqsimu', {opcion: 1}] });
    }
    if (permisos.includes("Impresion")) subitems.push({ text: 'Impresión', router: '/configuracion/resultadosLiqImp' });
    if (permisos.includes("Resultado Liquidacion")) subitems.push({ text: 'Transferencia Bancaria', router: '/configuracion/reporteTransferencia' });

    //Reportes Generales
    subitems2 = [{ text: 'Registro de inicio 2', router: '' }];
    if (permisos.includes("Resultado Liquidacion")) 
    {
      subitems2.push({ text: 'Resultados Nómina', router: '/configuracion/reporteResultadosNomina' });
      subitems2.push({ text: 'Códigos de Nómina', router: '/configuracion/reporteCodigosNomina' });
    }
    if (permisos.includes("Borrar Liquidacion")) subitems2.push({ text: 'Borrado Resultados Nómina', router: '/configuracion/borradoResultadosNomina' });
    subitems2.splice(0,1);
    if (subitems2.length > 0)
    {
      subitems.push({ text: 'Reportes Generales',  children: subitems2});
    }

    //Reportes Paraguay
    subitems3 = [{ text: 'Registro de inicio 3', router: '' }];
    if (permisos.includes("Reporte IPS")) subitems3.push({ text: 'Reporte IPS', router: '/configuracion/reporteIPS' });
    if (permisos.includes("Reporte IRP")) subitems3.push({ text: 'Reporte IRP', router: '/configuracion/reporteIRP' });
    if (permisos.includes("Reporte MTESS")) subitems3.push({ text: 'Reporte MTESS', router: '/configuracion/reporteMTESS' });
    subitems3.splice(0,1);
    if (subitems3.length > 0)
    {
      subitems.push({ text: 'Reportes Paraguay',  children: subitems3});
    }
    //Reportes Uruguay
    subitems4 = [{ text: 'Registro de inicio 4', router: '' }];
    if (permisos.includes("Reporte URU")) subitems4.push({ text: 'En desarrollo...', router: '/configuracion/reporteURU' });
    subitems4.splice(0,1);
    if (subitems4.length > 0)
    {
      subitems.push({ text: 'Reportes Uruguay',  children: subitems4});
    }

    subitems.splice(0,1);
    if (subitems.length > 0)
    {
      this.menuProvi[4] = { text: 'Liquidación', class: 'fa fa-calculator', children: subitems};
    } else
    {
      this.menuProvi.splice(4,1);
    }

    //Opcion 3 - Gestión Organización -> Revisa permiso y la elimina del menu si no lo tiene
    subitems = [{ text: 'Registro de inicio', router: '' }];
    if (permisos.includes("Ver Funciones")) subitems.push({ text: 'Funciones', router: '/configuracion/funciones' });
    if (permisos.includes("Ver Centro de Costos")) subitems.push({ text: 'Centro de Costos', router: '/configuracion/centroCostos' });
    if (permisos.includes("Ver Unidades Organizativas")) subitems.push({ text: 'Unidades Organizativas', router: '/configuracion/unidadesOrganizativas' });
    if (permisos.includes("Ver Posiciones")) 
    {
      subitems.push({ text: 'Posiciones', router: '/configuracion/posiciones' });
      subitems.push({ text: 'Organigrama', router: '/configuracion/organigrama' });
    }
    subitems.splice(0,1);
    if (subitems.length > 0)
    {
      this.menuProvi[3] = { text: 'Gestión Organización', class: 'fa fa-sitemap', children: subitems};
    } else
    {
      this.menuProvi.splice(3,1);
    }

    //Opcion 2 - Formulas -> Revisa permiso y la elimina del menu si no lo tiene
    if (!permisos.includes("Ver Formulas")) this.menuProvi.splice(2,1);

    //Opcion 1 - Personal -> Revisa permiso y la elimina del menu si no lo tiene
    subitems = [{ text: 'Registro de inicio', router: '' }];
    if (permisos.includes("Alta Persona Sociedad")) subitems.push({ text: 'Alta Personal', router: '/personal/alta' });
    if (permisos.includes("Ver Ficha Medica")) subitems.push({ text: 'Ficha Médica y Sanciones', router: '/personal/fichaMedica' });
    if (permisos.includes("Importacion Personal")) subitems.push({ text: 'Importación Datos Personal', router: '/personal/importacionPersonal' });

    //Reportes Personal
    subitems2 = [{ text: 'Registro de inicio 2', router: '' }];
    if (permisos.includes("Lista Personas Sociedad")) subitems2.push({ text: 'Lista Personal', router: '/personal/listaPersonas' });
    if (permisos.includes("Reporte Constancia")) subitems2.push({ text: 'Impresión Constancia', router: '/personal/impresionConstancia' });
    // if (permisos.includes("Ver Ficha Medica")) subitems2.push({ text: 'Fichas Médicas', router: '/personal/listaPersonas' });
    subitems2.splice(0,1);
    if (subitems2.length > 0)
    {
      subitems.push({ text: 'Reportes Personal',  children: subitems2});
    }

    subitems.splice(0,1);
    if (subitems.length > 0)
    {
      this.menuProvi[1] = { text: 'Personal', class: 'fa fa-users', children: subitems};
    } else
    {
      this.menuProvi.splice(1,1);
    }
      
    
    //Menu definitivo
    this.menuData = this.menuProvi;
  }

  cambiarContrasenia(): void
  {
    this.router.navigate(['/usuario/change']);
  }

}
